import { View } from 'react-native'
import styled from 'styled-components'
import { PlanPromoBlockV1 } from '../PlanPromoBlockV1/PlanPromoBlockV1'

export const NoteArea = styled(View)`
  margin: ${(props) => props.theme.spacing.smedium}px 0;
`

export const Description = styled(PlanPromoBlockV1.BillingNoteEmphasised)`
  margin-top: 0;
  font-size: ${(props) => props.theme.fontSizes.xsmall}px;
`

export const LimitedOffer = styled(PlanPromoBlockV1.BillingNoteEmphasised)`
  margin-top: ${(props) => props.theme.spacing.medium}px;
  color: ${(props) => props.theme.colors.primary};
`

export const PlanBenefits = ({ chosenPlan, monthlyPlan }) => {
  if (!chosenPlan || !monthlyPlan) {
    return null
  }

  // Always use the full monthly plan benefits
  const { benefits } = monthlyPlan.promoBlock.v1
  const { benefitsMore, billingNoteEmphasised } = chosenPlan.promoBlock.v1
  const benefitItems = [
    ...benefits.items,
    ...(chosenPlan !== monthlyPlan && benefitsMore ? benefitsMore.items : []),
  ]

  return (
    <PlanPromoBlockV1.Block>
      <PlanPromoBlockV1.Title>{chosenPlan.title}</PlanPromoBlockV1.Title>
      <PlanPromoBlockV1.BulletList icon={benefits.icon} items={benefitItems} />
      <NoteArea>
        <PlanPromoBlockV1.BillingNoteEmphasised>
          {billingNoteEmphasised}
        </PlanPromoBlockV1.BillingNoteEmphasised>
      </NoteArea>
    </PlanPromoBlockV1.Block>
  )
}
